import type { Resolvers } from '../../generated';
import { uploaderConfigsMap } from './uploader-configs';

export const resolvers: Resolvers = {
  Mutation: {
    removeUploaderConfig: (_, { key }) => {
      uploaderConfigsMap.update(key, null);
      return false;
    },
  },
};
